module.exports = __webpack_public_path__ + "static/media/nav4_yt.86040e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav4_yt.png
// module id = 243
// module chunks = 0